<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title icon-color="teal" icon="mdi-home-variant" title="Depolar" desc="Stok depolarının ekleme/çıkarma yönetilmesini sağlayabilirsiniz" />
      </v-col>
      <v-col cols="3">
        <stok-navigasyon />
      </v-col>
      <v-col cols="9"></v-col>
    </v-row>
  </v-container>
</template>

<script>
import PanelTitle from '../../../components/PanelTitle.vue'
import StokNavigasyon from './StokNavigasyon.vue'
export default {
  components: { PanelTitle,StokNavigasyon },
    name: "StokDepolar",
    
}
</script>

<style>

</style>